import Mark from "./Mark.ts";
import MarkText from "../components/MarkText.ts";
import {Container, Graphics, Sprite, Text, TextStyle} from "pixi.js";
import DecodingModel from "../models/DecodingModel.ts";
import IMark from "../interfaces/IMark.ts";
import RhColors from "@/models/RhColors.ts";

export default class SoundOfFMark extends Mark implements IMark
{
    public get targetX():number
    {
        if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
                this._targetX = 0;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this._targetY = this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }

    private _init():void
    {
        if(this.targetTextField)
        {
            this.fontSize = this.adjustToScale(96);
            this.parentTarget = this.targetTextField;
            this.markY = this.targetTextField.height/2-(this.adjustToScale(108)*this.multipleOfDefaultFontSize);
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        const text = "f";
        const style = new TextStyle({
            fontFamily: DecodingModel.getInstance().fontFamily,
            fontSize: this.fontSize,
            fill: color,
            align: 'center'
        });
        let mark = new Text({text:text, style:style});
        this.addChild(mark);
        this.markWidth = mark.width;
        this.markHeight = mark.height;
        if(this.targetTextField)
        {
            this.pivot.x = this.markWidth/2;
            this.pivot.y = this.markHeight/2;
        }
        mark.visible = visible;
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks()
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}